<template>
  <v-dialog persistent width="560" v-model="active">
    <v-card class="ui-module-card condecoracion-dialog" color="primary">
      <v-card-title class="ui-module-titlebar d-flex align-center">
        <div class="text-h6 font-weight-bold">Asignación de condecoración a personal</div>
        <v-spacer></v-spacer>
        <v-btn icon color="error" @click="closeDialog()"><v-icon>mdi-window-close</v-icon></v-btn>
      </v-card-title>
      <v-card-text class="pb-2">
        <v-form v-model="form" class="ui-dialog-form">
          <v-select
            v-model="condecoracion.fk_idCatCondecoracion"
            class="ui-form-field mt-2"
            rounded
            filled
            dense
            hide-details
            color="secondary"
            background-color="transparent"
            :items="condecoraciones"
            item-value="id"
            item-text="condecoracion"
            item-color="secondary"
          >
            <template v-slot:label>Condecoración <span class="red--text">*</span> </template>
          </v-select>
          <v-menu
            v-model="menu"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                :value="condecoracion.fechaCondecoracion"
                label="Fecha de condecoración"
                append-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
                class="ui-form-field"
                rounded
                filled
                dense
                hide-details
                color="secondary"
                background-color="transparent"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="condecoracion.fechaCondecoracion"
              class="ui-date-picker"
              @input="menu = false"
            ></v-date-picker>
          </v-menu>
          <v-textarea
            v-model="condecoracion.observaciones"
            label="Observaciones"
            class="ui-form-textarea"
            rounded
            filled
            dense
            hide-details
            color="secondary"
            background-color="transparent"
            no-resize
            rows="6"
          ></v-textarea>
        </v-form>
      </v-card-text>
      <v-card-actions class="justify-center ui-module-actions pb-6">
        <v-btn
          class="ui-module-btn-solid px-6"
          color="secondary"
          large
          :loading="loading"
          :disabled="!form || loading"
          @click="triggerSaveCondecoracionPersonal()"
          >Asignar condecoración</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  props: {
    active: {
      type: Boolean,
    },

    personal: {
      type: Object,
    },
  },

  data() {
    return {
      form: false,
      menu: false,
      loading: false,

      condecoracion: {
        fk_idPersonal: null,
        fk_idCatCondecoracion: null,
        fechaCondecoracion: null,
        observaciones: '',
      },
    }
  },

  computed: {
    ...mapGetters('condecoraciones', {
      condecoraciones: 'getCondecoraciones',
    }),
  },

  methods: {
    ...mapActions('condecoracionPersonal', ['saveCondecoracionPersonal']),

    closeDialog() {
      this.$emit('close')
      this.condecoracion = {
        fk_idPersonal: null,
        fk_idCatCondecoracion: null,
        fechaCondecoracion: null,
        observaciones: '',
      }
      this.loading = false
    },

    async triggerSaveCondecoracionPersonal() {
      this.loading = true
      this.condecoracion.fk_idPersonal = this.personal.idPersonal
      await this.saveCondecoracionPersonal(this.condecoracion)

      this.closeDialog()
    },
  },
}
</script>

<style scoped>
.condecoracion-dialog {
  overflow: hidden;
}

.ui-dialog-form {
  display: grid;
  gap: 12px;
}

::v-deep .ui-form-field .v-input__control > .v-input__slot,
::v-deep .ui-form-textarea .v-input__control > .v-input__slot {
  background: rgba(16, 16, 30, 0.35) !important;
  border: 1px solid rgba(var(--v-secondary-base-rgb, 255, 165, 2), 0.22) !important;
  border-radius: 12px !important;
  box-shadow: none !important;
  transition: all 0.25s ease !important;
}

::v-deep .ui-form-field .v-input__control > .v-input__slot:hover,
::v-deep .ui-form-textarea .v-input__control > .v-input__slot:hover {
  border-color: rgba(var(--v-secondary-base-rgb, 255, 165, 2), 0.38) !important;
}

::v-deep .ui-form-field.v-input--is-focused .v-input__control > .v-input__slot,
::v-deep .ui-form-textarea.v-input--is-focused .v-input__control > .v-input__slot {
  background: rgba(16, 16, 30, 0.48) !important;
  border-color: var(--v-secondary-base) !important;
  box-shadow: 0 0 0 2px rgba(var(--v-secondary-base-rgb, 255, 165, 2), 0.12) !important;
}

::v-deep .ui-form-field .v-label,
::v-deep .ui-form-field .v-icon,
::v-deep .ui-form-textarea .v-label {
  color: rgba(224, 224, 224, 0.68) !important;
}

::v-deep .ui-form-field input,
::v-deep .ui-form-textarea textarea,
::v-deep .ui-form-field .v-select__selection {
  color: #e0e0e0 !important;
}

::v-deep .ui-form-field.v-input--is-focused .v-label,
::v-deep .ui-form-field.v-input--is-focused .v-icon,
::v-deep .ui-form-textarea.v-input--is-focused .v-label {
  color: var(--v-secondary-base) !important;
}

::v-deep .ui-date-picker {
  background: #111827 !important;
  border: 1px solid rgba(var(--v-secondary-base-rgb, 255, 165, 2), 0.16);
}
</style>
